export default "__VITE_ASSET__FsY$08s6__"